'use client'

import { useState } from 'react'

import Fuse from 'fuse.js'
import { SearchIcon } from 'lucide-react'

import { useHelpCenterStore } from '../stores/useHelpCenterStore'

import type { Post } from '@/features/help-center/types/post'
import { useModalContext } from '@/shared/contexts/Modal'
import { Card, CardHeader, CardBody, CardTitle } from '@/shared/ui/Card'
import { Input } from '@/shared/ui/input'
import { inputClassName } from '@/shared/ui/input-styles'

import { PostCard } from './PostCard'
import { PostModal } from './PostModal'



export const PostList = () => {
  const { posts } = useHelpCenterStore()
  const { openModal } = useModalContext()
  const [search, setSearch] = useState('')
  const hasSearch = !!search.trim()
  const fuse = new Fuse(posts, {
    keys: ['name', 'description'],
    threshold: 0.3
  })

  const handleClick = (post: Post) => {
    openModal(
      {
        modal: PostModal
      },
      {
        post
      }
    )
  }

  const handleSearchChange = (value: string) => {
    setSearch(value)
  }

  return (
    <div className="flex flex-col gap-4 w-full items-center">
      <Card variant="lightBlue">
        <CardHeader>
          <CardTitle>Central de Ajuda</CardTitle>
        </CardHeader>
        <CardBody>
          <div className="flex items-center relative h-[41px] mb-6">
            <Input
              className={inputClassName}
              placeholder="Qual sua dúvida?"
              value={search}
              onChange={e => handleSearchChange(e.target.value)}
            />
            <button className="absolute right-0 top-0 h-full bg-jacaranda text-white px-5 rounded-r-md inset-shadow-[0_-3px_0_0_#6B64B7]">
              <SearchIcon className="" />
            </button>
          </div>
          <div className="flex flex-col gap-4">
            {hasSearch
              ? fuse
                  .search(search)
                  .map(result => (
                    <PostCard
                      key={result.item.id}
                      post={result.item}
                      onClick={() => handleClick(result.item)}
                    />
                  ))
              : posts.map(post => (
                  <PostCard
                    key={post.id}
                    post={post}
                    onClick={() => handleClick(post)}
                  />
                ))}
          </div>
        </CardBody>
      </Card>
    </div>
  )
}
